if (!customElements.get("accordion-group")) {
  class AccordionGroup extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === "true") return;
      this.dataset.ready = "true";

      this.items = Array.from(this.querySelectorAll(".accordion__item"));
      this.closeOthersEnabled = this.dataset.closeOthers !== "false";

      this.items.forEach((item) => {
        const header = item.querySelector(".accordion__header");
        const content = item.querySelector(".accordion__content");

        if (!header || !content) return;

        if (item.dataset.open === "true" || item.classList.contains("active")) {
          item.classList.add("active");
          header.setAttribute("aria-expanded", "true");
          content.style.maxHeight = content.scrollHeight + "px";
        }

        header.addEventListener("click", () => {
          if (this.closeOthersEnabled) {
            this.closeOthers(item);
          }

          this.toggleItem(item);
        });

        const images = content.querySelectorAll("img");

        images.forEach((image) => {
          image.addEventListener("load", () => {
            this.updateItemHeight(item);
          });
        });
      });

      window.addEventListener("resize", () => {
        this.updateActiveHeights();
      });
    }

    closeOthers(currentItem) {
      this.items.forEach((item) => {
        if (item === currentItem) return;

        const header = item.querySelector(".accordion__header");
        const content = item.querySelector(".accordion__content");

        item.classList.remove("active");

        if (header) {
          header.setAttribute("aria-expanded", "false");
        }

        if (content) {
          content.style.maxHeight = null;
        }
      });
    }

    toggleItem(item) {
      const header = item.querySelector(".accordion__header");
      const content = item.querySelector(".accordion__content");

      if (!content) return;

      const isActive = item.classList.toggle("active");

      if (header) {
        header.setAttribute("aria-expanded", isActive ? "true" : "false");
      }

      if (isActive) {
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.style.maxHeight = null;
      }
    }

    updateItemHeight(item) {
      if (!item.classList.contains("active")) return;

      const content = item.querySelector(".accordion__content");

      if (content) {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    }

    updateActiveHeights() {
      this.items.forEach((item) => {
        this.updateItemHeight(item);
      });
    }
  }

  customElements.define("accordion-group", AccordionGroup);
}
